<template>
  <div class="my-5" :class="col ? `col-lg-${col}` : ''">
    <!-- ========== Start:: Text || Number || Tel || Email Input ========== -->
    <div
      :class="{
        errors: errors,
        top_label: true,
        input_wrapper: true,
      }"
      v-if="
        type === 'text' ||
        type === 'number' ||
        type === 'tel' ||
        type === 'email' ||
        type === 'date' ||
        type === 'time'
      "
    >
      <label class="form-label">
        <img v-if="icon" :src="icon" class="img" />
        {{ placeholder }}

        <span class="text-danger" v-if="required">*</span>
      </label>
      <input
        :id="$attrs.id"
        :class="{
          'form-control': true,
          error: errors,
          class: true,
        }"
        :type="type"
        :value="value"
        @click="$emit('fireClick')"
        :dir="getAppLocale == 'ar' && type == 'tel' ? 'rtl' : ''"
        @input="updateValue($event)"
        :readonly="readonly"
        :disabled="disabled"
        @blur="onBlur"
      />
    </div>
    <!-- ========== End:: Text || Number || Tel || Email Input ========== -->

    <!-- ========== Start:: Password Input ========== -->
    <div
      class="input_wrapper top_label password_input_wrapper"
      :class="{
        errors: errors,
      }"
      v-else-if="type === 'password'"
    >
      <label class="form-label">
        {{ placeholder }}
        <span class="text-danger" v-if="required">*</span>
      </label>
      <input
        :class="{
          'form-control': true,
        }"
        :type="passwordIsVisible ? 'text' : 'password'"
        :value="value"
        @input="updateValue($event)"
        @focus="onBlur"
        @blur="onBlur"
        :readonly="readonly"
        :disabled="disabled"
        onfocus="this.removeAttribute('readonly');"
      />
      <button
        type="button"
        class="password_visibility_toggler"
        @click="passwordIsVisible = !passwordIsVisible"
      >
        <i class="fal fa-eye" v-if="passwordIsVisible"></i>
        <i class="fal fa-eye-slash" v-else></i>
      </button>
    </div>
    <!-- ========== End:: Password Input ========== -->

    <!-- ========== Start:: Textarea Input ========== -->
    <div
      :class="{
        'form-control': true,
        errors: errors,
      }"
      class="input_wrapper top_label"
      v-if="type === 'textarea'"
    >
      <label class="form-label">
        <img v-if="icon" :src="icon" class="img" />

        {{ placeholder }}
        <span class="text-danger" v-if="required">*</span>
      </label>
      <textarea
        :class="{
          'form-control': true,
          error: errors,
        }"
        :rows="rows"
        :value="value"
        @input="updateValue($event)"
        :readonly="readonly"
        :disabled="disabled"
        @blur="onBlur"
      >
      </textarea>
    </div>
    <p v-if="errors" class="error-msg">{{ errors }}</p>
    <!-- ========== End:: Textarea Input ========== -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "BaseInput",

  inheritAttrs: false,

  emits: ["fireClick"],

  props: {
    icon: {
      required: false,
      type: String,
    },
    errors: {
      requireed: false,
      type: String,
    },
    col: {
      required: false,
      type: Number | String,
    },
    value: {
      required: true,
    },
    type: {
      required: true,
      type: String,
    },
    placeholder: {
      required: false,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
      default: false,
    },
    readonly: {
      required: false,
      type: Boolean,
      default: false,
    },
    disabled: {
      required: false,
      type: Boolean | Number,
      default: false,
    },
    // ====== End:: General Inputs Props ====== //

    // ====== Start:: Textarea Input Props ====== //
    rows: {
      required: false,
      type: String,
      default: "4",
    },
    // ====== End:: Textarea Input Props ====== //
  },

  data() {
    return {
      // Start:: Password Visibility Data
      passwordIsVisible: false,
      // End:: Password Visibility Data
    };
  },

  methods: {
    updateValue(e) {
      this.$emit("input", e.target.value);
    },

    onBlur(event) {
      this.$emit("blur", event);
    },
  },
  computed: {
    // START:: VUEX GET APP THEME
    ...mapGetters("AppLangModule", ["getAppLocale"]),
    // END:: VUEX GET APP THEME
  },
};
</script>
<style scoped>
.error-msg {
  color: #f44336 !important;
}

.input_wrapper.errors {
  border-color: #f44336 !important;
  background-color: transparent !important;
}
.input_wrapper.errors label {
  color: #f44336 !important;
}
.form-label .img {
  width: 25px;
  border-radius: 50%;
  height: 25px;
  display: inline-block;
   object-fit: cover;
}
</style>
